import { AuthLayout } from '#components/patterns/layouts/auth/AuthLayout.tsx';
import { LoadingSpinner } from '#screens/loading/LoadingSpinner.tsx';

/**
 * Shows a loading spinner in an auth layout (pages with a top bar, and no nav sidebar)
 */
export function LoadingAuthPage() {
  return (
    <AuthLayout centerVertically={true}>
      <LoadingSpinner />
    </AuthLayout>
  );
}
